var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-panel-base',{attrs:{"color":_vm.error ? 'red' : 'white',"gap":"2","direction":"column"}},[_c('ui-heading',[_vm._v("Summary")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }